import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Calendar, ArrowRight } from 'lucide-react';
import axios from 'axios';
import SEO from '../components/SEO';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPage() {
  const { t, language } = useLanguage();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then(r => setPosts(r.data)).catch(() => {});
  }, []);

  const getLocalized = (item, field) => item[`${field}_${language}`] || item[`${field}_de`] || '';

  return (
    <div data-testid="blog-page">
      <SEO page="blog" />
      {/* Hero */}
      <section className="relative py-20 md:py-28 bg-[#0F172A]">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '40px 40px'}} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <span className="inline-block text-[#3b8dff] text-sm font-semibold uppercase tracking-wider mb-4">{t('blog.tag')}</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6" data-testid="blog-title">{t('blog.title')}</h1>
        </div>
      </section>

      {/* Posts */}
      <section className="py-20 md:py-32 blueprint-bg">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {posts.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((post, i) => (
                <article key={post.id || i} className="bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200 hover:shadow-xl transition-all group" data-testid={`blog-post-${i}`}>
                  <div className="aspect-[16/9] overflow-hidden">
                    <img src={post.image || '/api/uploads/service_framework.jpg'} alt={getLocalized(post, 'title')} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-xs text-slate-500 mb-3">
                      <Calendar className="w-3 h-3" />
                      {post.created_at ? new Date(post.created_at).toLocaleDateString(language === 'de' ? 'de-DE' : language === 'es' ? 'es-ES' : 'en-US') : ''}
                      {post.author && <span>| {post.author}</span>}
                    </div>
                    <h3 className="text-lg font-bold text-[#0F172A] mb-2 group-hover:text-[#066ce7] transition-colors">{getLocalized(post, 'title')}</h3>
                    <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3">{getLocalized(post, 'excerpt')}</p>
                    <span className="inline-flex items-center text-[#066ce7] text-sm font-semibold gap-1 group-hover:gap-2 transition-all cursor-pointer">
                      {t('blog.readmore')} <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <p className="text-center text-slate-500 py-20">
              {language === 'de' ? 'Keine Beiträge vorhanden.' : language === 'en' ? 'No posts available.' : 'No hay publicaciones disponibles.'}
            </p>
          )}
        </div>
      </section>
    </div>
  );
}
